export default "__VITE_ASSET__DIqM0myl__"